import { message, notification } from "antd";
import { fetchAuthSession } from "aws-amplify/auth";
import axios from "axios";
import { logOut } from "../helpers/authFunctions";
import { GET_LOCAL_STORAGE, LOCAL_STORAGE_KEY } from "../helpers/localStorage";
import { LOGGER } from "../helpers/logger";
import { API_CONSTANTS } from "./Constants";
import { showError } from "../helpers/alerts";
// async function currentAuthenticatedUser() {
//   try {
//     const session = await fetchAuthSession();
//     return session?.tokens?.idToken?.toString();
//   } catch (err) {
//     LOGGER("Log From Interceptor:", err);
//   }
// }
// Create Axios instance
const axiosHttp = axios.create({
  baseURL: API_CONSTANTS.BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to set the Authorization header
axiosHttp.interceptors.request.use(
  async (config) => {
    // config.headers["X-Custom-Header"] = "Custom Header Value";
    try {
      LOGGER("Request-->", `${"baseURL/"}${config.url}`);
      let token = GET_LOCAL_STORAGE(LOCAL_STORAGE_KEY.cognitoJWTIdentity);
      let isUserAliveInCognito = GET_LOCAL_STORAGE(
        LOCAL_STORAGE_KEY.cognitoIdentity
      );
      if (isUserAliveInCognito && token) {
        // config.headers.Authorization = `${token}`;
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        message.warning("Your Session Expired!");
        // notification.warning({
        //   message: "Session Expired!",
        //   description: "Your session has been expired. Please log in again.",
        //   placement: "top",
        // });
        logOut();
      }
    } catch (error) {
      LOGGER("Log From Interceptor:", error);
    }
    return config;
  },
  (error) => {
    showError(error.message);
    return Promise.reject(error);
  }
);
// Response interceptor
axiosHttp.interceptors.response.use(
  (response) => {
    LOGGER("Log From Interceptor:", response);

    if (response.data.statusCode == 500) {
      showError("API Internal server error!");
      // response.data.body ||
    } else {
      return response;
    }
  },
  (error) => {
    // LOGGER("Error From Axios interceptor", error.response.message);
    // console.log("===errrrrrrrr======>", error.response.data.message);
    if (error.response.data.message == "The incoming token has expired") {
      logOut();
    }
    if (
      error.response.status == 403 &&
      error.response.data.message ==
        "User is not authorized to access this resource with an explicit deny"
    ) {
      message.warning("Your Session Expired!");
      logOut();
    }
    if (error.message) {
      if (error.response.data.message.message) {
        showError(`${error.response.data.message.message}`);
      } else {
        // showError(`API ${error.message}`);
      }
    } else {
      showError(`${error}`);
    }
    // return Promise.reject(error);
  }
);

export default axiosHttp;
